// Module: system. System states (lock, maintenance, forbidden, loading, error,
// empty) are shell-owned; this module owns the node activation screen
// (system/activation--desktop).
//
//   /activate            PUBLIC, pre-login (systemPublicRoutes) — shown whenever
//                        erp-core's licence status says `licensed:false` on a
//                        node (NodeLicenceGate), whatever `erp.local-mode` says.
//   /setup               PUBLIC, pre-login — the node's first run: create the
//                        owner with the one-time code from the erp-core log
//                        (GET /v1/erp/auth/status `bootstrap_required:true`).
//   /system/activation   inside the shell, node + owner only: renew / replace a
//                        valid licence (erp-core requires the owner for that).

import { ShieldCheck } from 'lucide-react';
import { defineModule, gate } from '@/app/module-types';
import { ActivationScreen } from './screens/Activation';

export { ActivationScreen, ACTIVATION_TEXT } from './screens/Activation';
export { FirstRunScreen, FIRST_RUN_TEXT } from './screens/FirstRun';
export {
  ACTIVATE_PATH,
  NodeLicenceGate,
  SETUP_PATH,
  systemPublicRoutes,
  useNodeBootstrapRequired,
  useNodeUnlicensed,
  withNodeLicenceGate,
} from './NodeLicenceGate';
export {
  ACTIVATION_COPY,
  activationError,
  AUTH_STATUS_KEY,
  fetchLicenceStatus,
  fetchNodeAuthStatus,
  FIRST_RUN_COPY,
  LICENCE_STATUS_KEY,
  useLicenceStatus,
  useNodeAuthStatus,
  type LicenceStatus,
  type NodeAuthStatus,
} from './data/api';

export default defineModule({
  key: 'system',
  label: 'النظام',
  icon: ShieldCheck,
  flag: null,
  minRole: 'staff',
  rail: null,
  routes: [{ path: '/system/activation', element: <ActivationScreen variant="renew" />, handle: gate({ modes: ['node'], minRole: 'owner' }) }],
  menu: [],
});
